/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React from 'react';
import PropTypes from 'prop-types';
import BsPagination from 'react-bootstrap/Pagination';
import { createUltimatePagination, ITEM_TYPES } from 'react-ultimate-pagination';

import './styles.css';

// A replacement for the legacy @react-bootstrap/pagination
// as recommended in https://github.com/react-bootstrap/pagination#alternatives
const UltimatePagination = createUltimatePagination({
  WrapperComponent: BsPagination,
  itemTypeToComponent: {
    // eslint-disable-next-line react/prop-types
    [ITEM_TYPES.PAGE]: ({value, isActive, onClick}) => (
      <BsPagination.Item active={isActive} onClick={onClick}>{value}</BsPagination.Item>
    ),
    // eslint-disable-next-line react/prop-types
    [ITEM_TYPES.ELLIPSIS]: ({ isActive, onClick }) => (
      <BsPagination.Ellipsis disabled={isActive} onClick={onClick} />
    ),
    [ITEM_TYPES.FIRST_PAGE_LINK]: ({ isActive, onClick }) => (
      !isActive && <BsPagination.First disabled={isActive} onClick={onClick}>« First</BsPagination.First>
    ),
    [ITEM_TYPES.PREVIOUS_PAGE_LINK]: ({ isActive, onClick }) => (
      !isActive && <BsPagination.Prev disabled={isActive} onClick={onClick}>‹ Previous</BsPagination.Prev>
    ),
    [ITEM_TYPES.NEXT_PAGE_LINK]: ({ isActive, onClick }) => (
      !isActive && <BsPagination.Next disabled={isActive} onClick={onClick}>Next ›</BsPagination.Next>
    ),
    [ITEM_TYPES.LAST_PAGE_LINK]: ({ isActive, onClick }) => (
      !isActive && <BsPagination.Last onClick={onClick}>Last »</BsPagination.Last>
    )
  }
});

const Pagination = ({ activePage, pageCount, pageSelect, children }) => {
  return (
    <div>
      {children}
      {pageCount > 1 &&
        <UltimatePagination
          bsPrefix="auth0-pagination"
          currentPage={+activePage}
          totalPages={pageCount}
          onChange={pageSelect}
        />
      }
    </div>
  );
};

Pagination.propTypes = {
  activePage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  pageSelect: PropTypes.func.isRequired,
  children: PropTypes.node
};

Pagination.defaultProps = {
  activePage: 1,
  pageCount: 1,
  pageSelect: 1
};

export default Pagination;
